// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  editId: __t.u64().primaryKey().name("edit_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  radius: __t.f32(),
  value: __t.f32(),
  layer: __t.u8(),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
});
